'use client';
var classes = {"month":"m-cc9820d3","monthCell":"m-8f457cd5"};

export default classes;
//# sourceMappingURL=Month.module.mjs.map
